import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const PartList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `PartList_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.PARTS,
        method: HttpMethod.GET,
      }),
  };
};
